/**
 * Constant Key 정보
 */

/**
 * 권한 정보
 */
export const ADMIN_ROLE = '10'

export const VEN_ROLE = '20'

export const VEN2_ROLE = '30'

/**
 * Text Field Validation Rules
 */
export const RULES = {
  required: (value: string) => !!value || '필수입력 사항입니다.',
  idRequired: (value: string) => !!value || '아이디를 입력하세요.',
  pwRequired: (value: string) => !!value || '비밀번호를 입력하세요.',
  nameRequired: (value: string) => !!value || '이름을 입력하세요.',
  emailRequired: (value: string) => !!value || '이메일을 입력하세요.',
  hpRequired: (value: string) => !!value || '휴대폰번호를 입력하세요.',
  telRequired: (value: string) => !!value || '전화번호를 입력하세요.',
  slitmCdCount: (value: string) => (value && value.length > 2) || '3자 이상 입력해 주세요.',
  sitmNmCount: (value: string) => (value && value.length > 1) || '2자 이상 입력해 주세요.',
  imgSize: (value: File) => !value || value.size < 3000000 || '이미지 사이즈는 최대 3MB까지 가능합니다.',

  hp: (value: string) => {
    const pattern = HP_VALID
    return pattern.test(value) || '휴대폰번호 형식이 잘못되었습니다.'
  },
  tel: (value: string) => {
    const pattern = TEL_VALID
    return pattern.test(value) || '전화번호 형식이 잘못되었습니다.'
  },
  email: (value: string) => {
    const pattern = EMAIL_VALID
    return pattern.test(value) || '이메일 형식이 잘못되었습니다.'
  },
}

// Reg Pattren
export const TEL_VALID = /^\d{2,3}-\d{3,4}-\d{4}$/
export const HP_VALID = /^\d{3}-\d{3,4}-\d{4}$/
// 이메일
export const EMAIL_VALID = /^(([^<>[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
